// Constants for the application
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE || '/api/v1',
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  USER_DATA: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};

export const CACHE_TTL = {
  SHORT: 5 * 60 * 1000, // 5 minutes
  MEDIUM: 15 * 60 * 1000, // 15 minutes
  LONG: 60 * 60 * 1000, // 1 hour
  VERY_LONG: 24 * 60 * 60 * 1000, // 24 hours
};

export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 8,
  MAX_PASSWORD_LENGTH: 255,
  MIN_NAME_LENGTH: 2,
  MAX_NAME_LENGTH: 255,
  MAX_BIO_LENGTH: 1000,
  PHONE_REGEX: /^(\+?254|0)[17]\d{8}$/,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

export const CONTRIBUTION_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  VERIFIED: 'verified',
  REJECTED: 'rejected',
};

export const LOAN_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  ACTIVE: 'active',
  REPAID: 'repaid',
  DEFAULTED: 'defaulted',
};

export const MEMBER_ROLES = {
  ADMIN: 'admin',
  TREASURER: 'treasurer',
  MEMBER: 'member',
  SECRETARY: 'secretary',
};

export const CHAMA_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
};

export const PAYMENT_METHODS = {
  MPESA: 'mpesa',
  CASH: 'cash',
  BANK: 'bank',
};

export const FREQUENCY_OPTIONS = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  ANNUALLY: 'annually',
};

export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  CHAMAS: '/chamas',
  CONTRIBUTIONS: '/contributions',
  LOANS: '/loans',
  WELFARE: '/welfare',
  REPORTS: '/reports',
  SETTINGS: '/settings',
  PROFILE: '/profile',
};

export default {
  API_CONFIG,
  STORAGE_KEYS,
  HTTP_STATUS,
  PAGINATION,
  CACHE_TTL,
  VALIDATION,
  CONTRIBUTION_STATUS,
  LOAN_STATUS,
  MEMBER_ROLES,
  CHAMA_STATUS,
  PAYMENT_METHODS,
  FREQUENCY_OPTIONS,
  TOAST_TYPES,
  ROUTES,
};
